import { FC, lazy, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { createGlobalStyle, css, useTheme } from 'styled-components';
import { FInter, FlexBox, useBreakpoint, useIsMobile } from '@brg/ui';
import { Project, Tag } from '@brg/api';

import { ProjectsSearchBar, } from '../../components/projectsSearchBar/projectsSearchBar';
import { ICategoryLight } from '../../common';
import { ApplicationShared, CoreContainer, LayoutConst, useModal } from '../../../core';
import { DisplayType } from '../../constants/displayType';
import { SortingTypeIndex } from '../../constants/sortingType';
import { CreateLinkTo, LinkTo } from '../../constants/linkTo';
import { AppTester, getContextFromAppName, getCurrentAppName } from '../../../supporting';
import { isHSEDesignContext } from '../../../_deziiign/hsedesign/utils';
import { IndexTitle, OnlinesSpaceGrotesk } from '../../../_deziiign/hsedesign/components/IndexTitle';
import { ProjectsButchController } from '../../../core/controllers/ProjectsButchController';
import { EncodedStateFilter, useEncodedStateFilter } from '../../components/Filters'
import { flipDisplay } from '../../utils/display'
import { isHSEDesignOnlineContext } from '../../../_deziiign/online/utils';
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import './styles';

import {
  ADVERTISING_TAG_ID,
  ART_DIRECTION_TAG_ID,
  ART_TAG_ID,
  BASIC_DESIGN_TA_ID,
  BOOK_DESIGN_TAD_ID,
  CANTEMPORARY_ART_TAG_ID,
  COMMUNICATION_TAG_ID,
  CREATIVE_PROGRAMMING_TAG_ID,
  DESIGN_TAG_ID,
  DIGITAL_PRODUCT_TAG_ID,
  DURASOV_TAG_ID,
  FASHION_TAG_ID,
  HSEILLUSTRATION_TAG_ID,
  INTERACTIVE_DESIGN_TAG_ID,
  JEWELRY_TAG_ID,
  MEDIA_DESIGN_TAG_ID,
  MODERN_DESIGN_TAG_ID,
  OBJECT_DESIGN_TAG_ID,
  PACKAGING_TAG_ID,
  PHOTOGRAPHY_ART_TAG_ID,
  SOUND_ART_TAG_ID,
  TYPE_TAG_ID,
  VIDEO_ART_ART_TAG_ID,
  VISUAL_RES_TAG_ID_BL,
  VISUAL_RESEARCH_TAG_GRADUATION_BLACK,
  WEB_PUBLISH_TAG_ID
} from "../../constants/misc";

import {SortIcon} from '../../icons';
import useExtraFilter from "../../hooks/useExtraFilter";
import TagsTextBar from 'shared/components/TagsTextBar/TagsTextBar';
import useQueryState from 'shared/hooks/useQueryState';
import MobileSearchBar from 'shared/components/MobileSearchBar/MobileSearchBar';
import {SlideNavigation} from 'shared/components/slideNavigation';
import {
  BottomGroupWrapper,
  ButtonWrapper,
  Description,
  DescriptionWrapper,
  ExploreButtonFilled,
  ExploreButtonHollow,
  IFrameGlobal,
  OuterWrapper,
  ProjectControllerWrapper,
  BottomOuterContainer
} from './styles';
import {ProjectSearchBarSorting} from '../../components/projectsSearchBar/components/projectSearchBarSorting';
import {useDispatch, useSelector} from 'react-redux';
import {InfinityProjectsSelector} from 'shared/reducers/InfinityProjects';
import {ShowMoreContent} from '../designer/styles';
import {HseContextActions} from 'shared/reducers/hseCurrentContext';
import {useAuth} from '@brg/auth';
import {HSE_SORTING_IDX} from '../exploreHseContextsOldDeprecated/const/sorting_tsx';
import {DropdownTabs} from '../exploreHseContextsOldDeprecated/components/DropdownTabs';
import useScreenOffset from "../../hooks/useScreenOffset";
import useQuery from "../../hooks/useQuery";
import { Outer } from './styles';

const MapFrame = lazy(() => import("../ResearchPage/Research/Frames/MapFrame"));

const getUrl = (encodedState: string) => {
  if (window.location.pathname.startsWith('/map')) {
    return `/map/${encodedState}`;
  }
  if (window.location.pathname.startsWith('/deziiign')) {
    return `/deziiign/${encodedState}`;
  }
  if (AppTester.isOnlineHSEDesign()) {
    return '/projects' + CreateLinkTo.explore(encodedState)
  }
  return CreateLinkTo.explore(encodedState);
}

export enum HSEDESIGN_VIEW_TABS {
  design = 'design',
  art = 'art',
  fashion = 'fashion',
  illustration = 'illustration',
  all = 'all',
}
const OLD_HSE_SORTING_IDX = {
  "date": 14,
  "popular": 15
}

const sceletonOptions = {
  col: 4,
  w: 65,
  h: 20,
  gx: 10
}

const TAB_TAGS = {
  [HSEDESIGN_VIEW_TABS.design]: DESIGN_TAG_ID,
  [HSEDESIGN_VIEW_TABS.art]: ART_TAG_ID,
  [HSEDESIGN_VIEW_TABS.fashion]: FASHION_TAG_ID,
  [HSEDESIGN_VIEW_TABS.illustration]: HSEILLUSTRATION_TAG_ID,
  [HSEDESIGN_VIEW_TABS.all]: '',
}

const getTagFilterParam = (str: string) => {
  //@ts-ignore
  switch (TAB_TAGS[str]) {
    case DESIGN_TAG_ID:
      return [
        ADVERTISING_TAG_ID,
        ART_DIRECTION_TAG_ID,
        WEB_PUBLISH_TAG_ID,
        BOOK_DESIGN_TAD_ID,
        BASIC_DESIGN_TA_ID,
        COMMUNICATION_TAG_ID,
        CREATIVE_PROGRAMMING_TAG_ID,
        DIGITAL_PRODUCT_TAG_ID,
        INTERACTIVE_DESIGN_TAG_ID,
        MEDIA_DESIGN_TAG_ID,
        MODERN_DESIGN_TAG_ID,
        OBJECT_DESIGN_TAG_ID,
        PACKAGING_TAG_ID,
        TYPE_TAG_ID
      ]

    case ART_TAG_ID:
      return [
        CANTEMPORARY_ART_TAG_ID,
        PHOTOGRAPHY_ART_TAG_ID,
        VIDEO_ART_ART_TAG_ID
      ]

    case FASHION_TAG_ID:
      return [FASHION_TAG_ID, JEWELRY_TAG_ID]
    case HSEILLUSTRATION_TAG_ID:
      return [HSEILLUSTRATION_TAG_ID]
    default:
      return null
  }
}


const projectStatus = [1, 6];


export const ExploreView: FC= () => (
  <EncodedStateFilter getUrl={getUrl}>
    <ExploreViewInner/>
  </EncodedStateFilter>
);

export const Title = styled(FInter.MainTitleMediumDiv)`
  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 36px;
    line-height: 39px;
  }
`;

export const MobileFilterRow = styled.div<{ fixed?: boolean, importantWidth?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  ${(p) =>
          p?.fixed ? css`
            position: sticky;
            top: 48px;
            left: 0;
            width: auto;
            z-index: 99;
            background-color: ${p => p.theme.app.backgroundColor};
          ` : null}

  ${p => p.importantWidth ? css`
    width: 100%;
  ` : css`
    .ExploreViewInnerSearchTags {
      width: calc(100% - 100px);
    }
  `};

`;

export const MobileFilterSort = styled.div<{isLectureMedia?: boolean}>`
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: #909090;
  display: flex;
  align-items: center;

  ${({isLectureMedia}) => isLectureMedia && css`
    width: 145px;
    justify-content: flex-end;
  `}


  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

const ONLINES_PROJECT_INDEX = {
  1:
    "6ee1e54530f94f7780a5de98473a50b6",
  2:
    "b1e7ff644881488c9d90508feb43aaec",
  3:
    "1da8a8f928c847c185424d0799566fa2",
  4:
    "d095fa3d66ac466eac5ee8726cc73624",
  5:
    "bdb65705630b446bba6e8aa8e56a770b",
  6:
    "25d62d8eb0d24f049909cc039eabc6dc",
  7:
    "c0d68aba984d4eb79b2c398bf0b64ef1",
  8:
    "f333f38db48d4f49be966279882badaa",
  9:
    "78b3756c96f9447398d515ccf9cc4570",
  10:
    "4e6ce404cc294b6bbe2c85e10bf1b4e4",
  11:
    "59004c2e416c4a67a9d9db60edfa4e5e",
  12:
    "c8b400684d28485f913ad1cb0f0db25b",
  13:
    "789471b400e04d1e937169f86a9637b7",
  14:
    "2343708ca49f4e9e8f64991edb893e29",
  15:
    "4b0cfa65f2fb48d298e7fe0b07408b2d",
  16:
    "81efec2b492749f0a4b742d67812671f",
  17:
    "1de7210a0d0c4ee18ba27f4268f236ba",
  18:
    "9eee16ddba454c23a68432b554cc05d8",
  19:
    "d98e99fd878c4106aec7c84b2de73ddc",
  20:
    "ecac2ea4717843509d62ee5e4e70b220",
  21:
    "99150d626ec642d38b78378a5cee36a3",
  22:
    "7d411e61c69b4182b100b4025560f4d4",
  23:
    "a718c69553f34d31902708ccc7d2d4a5",
  24:
    "6c1835fd3d8d4921a1359025d154d22f",
  25:
    "158ead9efa1b4484bcfe1d1b720dadf9",
  26:
    "f971516688564bcf928fd35147b8bc5d",
  27:
    "957244c386d647ab88a4f50681c4d939",
  28:
    "1740a69fe35c4e9b83a4f3b4355ca011",
  29:
    "7cb092aa11584529aae1040bd126f1f8",
  30:
    "bed506e4c8754ba99d49d92098aeff59",
  31:
    "2f31b48203744d33a6951743e3a01c4a",
  32:
    "8fd94fa37ea04698a5e398a9e0df2c7d",
  33:
    "0919be6a05cb44fd9ad506b2a8ec0f84",
  34:
    "34fdba9e6090499fabc74bce0d14e098",
  35:
    "3c769f84d5504de6a716880b1828d0c7",
  36:
    "66ec15dd34fd4df59c936b17ad002038",
  37:
    "3c079419eb934e69bd616ff4564b6ac5",
  38:
    "1a32fc89c81348dcb1f2a864ea0b170a",
  39:
    "b4d486361af547b3be20259db823385c",
  40:
    "be196307d2914e85a67a25e11c4e0b10",
  41:
    "8efb8cc5066a44cd87066aba034cb864",
  42:
    "24bd5d27b18b48da86fd384e56768220",
  43:
    "9d2af64f6d624b60bf0e1d0d27c5e4a9",
  // 44:
  //   "90e08c46f80a4d1c943e79cf0c0bee1b",
  // 45:
  //   "4fef355b7ed8421b989c00eefc53602d",
  46:
    "974b5cfc690a404fbc4bc801d283b6af",
  47:
    "bcac028a01bb49df9e8e44b3b8c18f74",
  48:
    "a63c669a51984e4a9647be92668f2c5f",
  49:
    "e68ed2ce24294dd4ae037f5f45d773b1",
  50:
    "e6ae1dc6f9884a70bfe964c5fc6cfaba",
  51:
    "bcccee6eb19f4243872825d50cae1486",
  52:
    "cdc0d6bfd41644908db35d43835844a2",
  53:
    "d9da04ec4bd34350a8a603b1d2d6d722",
  54:
    "422e3d5b569941098bbc18ef103d2cff",
  55:
    "d5d007d27ecd4643822d0e0a5292d52f",
  56:
    "4811c9c857bb4b59a5de941b26e4baaa",
  57:
    "b6c8aa6605124cf9bef30e87a93e5819",
  58:
    "3ac9ad49c9d04a78b2f0cac2ad36f647",
  59:
    "5ea19804d1f14f6887787c57791d02ed",
  60:
    "56311823a38540bcb03d8b1ae966d7da",
  61:
    "c6b3472238bb411dac19561afb28d57b",
  62:
    "e90e9f0961b44dbca268e0ceb4070a6f",
  63:
    "758605d8281b49678ff33bc5a8555739",
  64:
    "c413e4915b0b4cb2925f7b34d607aa05",
  65:
    "70c13a513926454cab68cb4b2cd3be82",
  66:
    "8ba43ad663f548308b3435bf4a054894",
  67:
    "54d3fcf36eef446bb364bad479f5f170",
  68:
    "b7961d8966b24d60bd8de471737625e3",
  69:
    "2134550deefe449a838b1c89b1c66e58",
  70:
    "e71d463b590b4e07a4ca3cad0857d72d",
}

const ONLINES_PROJECT_ARRAY = [
  'b3eed99da0984d89abe6e38c9dd7071b',
  'b1e7ff644881488c9d90508feb43aaec',
  '52a5a72ddb5c4010ad154e9bf2d371c1',
  '5135677c840a4b8f9526394a3cafdac4',
  '444ff9724a3d4b9d9448059710cc030a',
  '63d2a338d14a446b86d52fe435c3003f',
  '1620c3f8edcc42f5b1e21ce69c02f23f',
  'f7c6633b2c204a209c09a8c48376c122',
  ...Object.values(ONLINES_PROJECT_INDEX)
];

export const ONLINES_PROJECT_ORDER_INDEX = ONLINES_PROJECT_ARRAY.reduce((result, item, index) => {
  return {
    ...result,
    [item]: index,
  }
}, {})


const BodyOverflowStyle = createGlobalStyle`
  body {
    overflow-y: scroll !important;
  }
`

const ExploreViewInner: FC = () => {
  const {
    sorting: sortingRaw,
    coords,
    zoom,
    display,
    tagIds,
    categoryIds,
    setSorting,
    setCoords,
    setZoom,
    setDisplay,
    setTagIds,
    setCategoryIds
  } = useEncodedStateFilter();
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const offset = useScreenOffset();
  const isMobile = useIsMobile();
  const location = useLocation();
  const { emit, token } = useAuth();
  const modal = useModal();
  const history = useHistory();
  const dispatch = useDispatch();
  const isAllProjectsPage = useRouteMatch(LinkTo.deziiign);
  const isDurasov = !!useRouteMatch(LinkTo.durasov);
  const isSamokatMap = !!useRouteMatch(LinkTo.samokatMap);
  const isOnlines = AppTester.isOnlines();
  const currentAppName = getCurrentAppName();
  const isDeziiign = currentAppName === 'deziiign';
  const isMediiia = currentAppName === 'mediiia';
  const isHseDeziiign = !!isAllProjectsPage;
  const isAgeytomesh = AppTester.isAgeytomesh();
  const isHSEDesign = AppTester.isHSEDesign();
  const isIFrame = location.pathname.includes('iframepath')
  const isMap = display === DisplayType.map;
  const variables = useQuery();
  const isAlumni = !!useRouteMatch('/alumni');

  const sorting = Number(sortingRaw);

  const is430 = useBreakpoint(430);
  const is830 = useBreakpoint(830);
  const is743 = useBreakpoint(743);

  const isBack = useSelector(InfinityProjectsSelector)?.isProjectPage;
  const prevTab = sessionStorage.getItem('lastTab');

  const [currentTab, setCurrentTab] = useState<HSEDESIGN_VIEW_TABS>(HSEDESIGN_VIEW_TABS.design);
  const [{ tab }, setQueryParams] = useQueryState();

  const [isScrollTop, setScrollTop] = useState<boolean>(false);
  const [iframePort, setIiframePort] = useState<any>(null)
  const [date, setDate] = useState(Date.now());
  const [extraFilter, onExtraFilterChange] = useExtraFilter();

  const tagExtraFilter = useMemo(
    () => (
      (((isBack && prevTab) ? prevTab : currentTab) === HSEDESIGN_VIEW_TABS.all || !isHSEDesign) ?
        {} :
        { tagIds: getTagFilterParam((isBack && prevTab) ? prevTab : currentTab) })
    , [currentTab, prevTab, isBack, isHSEDesign])

  useEffect(() => {
    if (isSamokatMap) setQueryParams({ display: 'map' }, { replace: true });
  }, [isSamokatMap])

  const preloadedTabs = useMemo(() => {
    return Object.entries(TAB_TAGS)?.map(([k, v]) => ({
      [k]: getTagFilterParam(k)
    }));
  }, [TAB_TAGS, getTagFilterParam])


  const sortingTitle = useMemo(
    () => sorting === 1 ? t('text.mainTitleByNew') : t('text.mainTitleByPopular'),
    [sorting, t]
  );

  const InfinityScrollNeeded = useMemo(
    () => ((AppTester.isHSEDesign() || AppTester.isDeziiign() || AppTester.isOnlines() || AppTester.isGeograffee()) && (location.pathname === '/' || location.pathname.startsWith('/alumni') ||  AppTester.isOnlines() || location.pathname.startsWith('/projects') || variables.display === 'grid'))
    , [location])

  const [projects, setProjects] = useState<Project[]>([]);

  const contextFilter = useMemo(() => {
    if (isAgeytomesh) {
      return { contexts: ["ageytomesh"], isContextIgnored: false };
    }
    if (isDurasov) {
      return { tagIds: [DURASOV_TAG_ID], isContextIgnored: true };
    }
    if (isHseDeziiign) {
      return { isContextIgnored: true };
    }
    if (isOnlines) {
      return {
        projectFilter: 2,
        projectIds: [
          ...ONLINES_PROJECT_ARRAY,
        ],
        limit: 200,
        projectStatus: [1],
        isContextIgnored: true,
        isLite: true,
        mainPage: true,
      }
    }
    if (isHSEDesign) {
      return {
        tagIds,
        isFilterReplaceTags: true,
        contexts: ['hsedesign'],
      };
    }
    return { tagIds };
  }, [isAgeytomesh, isHseDeziiign, tagIds, isDurasov]);


  useEffect(() => {
    if (isHSEDesign) {
    }
    return () => {
      dispatch(HseContextActions.reset({}));
    }
  }, [dispatch, isHSEDesign])

  useEffect(() => {
    if (!isOnlines) {
      if (isBack && prevTab && Object.values(HSEDESIGN_VIEW_TABS).includes(prevTab as HSEDESIGN_VIEW_TABS)) {
        setQueryParams({ tab: prevTab }, { replace: true });
        setCurrentTab(prevTab as HSEDESIGN_VIEW_TABS);
      }
    }
  }, [currentTab, setQueryParams, isBack, prevTab, tab, isOnlines])

  useEffect(() => {
    setProjects([])
    setDate(Date.now())
  }, [tagExtraFilter])

  useEffect(() => {
    if (categoryIds.length > 0 && ApplicationShared.application !== 'education') {
      setDate(Date.now())
    }
  }, [categoryIds]);

  useEffect(() => {
    if (isMap) {
      setDate(Date.now())
    }
  }, [isMap])

  const scrollInterval = () => {
    const val_1 = window.scrollY;
    setTimeout(() => {
      let res = window.scrollY
      if (res && res < val_1) {
        setScrollTop(true)
      }
    }, 1000)
  }

  const onIframeMessage = (msg: MessageEvent) => {}

  const onSetIframePort = (msg: MessageEvent) => {
    if(msg?.ports?.length) {
      const usedPort = msg?.ports[0]
      usedPort.onmessage = onIframeMessage
      setIiframePort(usedPort)
    }
  }

  useEffect(() => {
    let intervalId = setInterval(scrollInterval, 1000)
    if(isIFrame) {
      window.addEventListener('message', onSetIframePort)
    }
    return (() => {
      clearInterval(intervalId);
      window.removeEventListener('message', onSetIframePort)
    })
  }, [])

  const onTagsChange = useCallback(([firstTag]: Tag[]): void => {
    setTagIds([firstTag?.tagId])
    history.push(firstTag ? CreateLinkTo.tag(firstTag.tagId) : CreateLinkTo.explore())
    setDate(Date.now());
  }, [setTagIds, history]);

  const onCategoryChange = useCallback((category: ICategoryLight): void => {
    setCategoryIds(category.identifier !== 'all' && category.identifier ? [category.identifier] : []);
    setDate(Date.now());
  }, [setCategoryIds]);

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
    setDate(Date.now());
  }, [setSorting]);

  // const onCoordsChanged = useCallback((newCoords: any): void => {
  //   setCoords(newCoords);
  // }, [setCoords]);

  const onZoomChanged = useCallback((zoom: number): void => {
    setZoom(zoom);
  }, [setZoom]);

  const onCreateClick = useCallback(() => {
    if (token) {
      history.push(CreateLinkTo.projectCreate());
    } else {
      emit('login');
    }
  }, [token, history, emit]);

  const ctx = useMemo(() => {
    const ctx = getContextFromAppName(ApplicationShared.application);
    return ctx !== 'main' ? `${ctx}` : 'geograffee';
  }, []);

  const btnWrapper = useMemo(() => {
    const options = isOnlines ? {
      link1: "https://onlinesdesign.com/graphic-design-basic-level#form",
      link2: "https://onlinesdesign.com/school",
      text1: t('onlinesNav.btns.learning'),
      text2: t('onlinesNav.btns.about'),
      target: '_self',
    } : {
      link1: "https://design.hse.ru/",
      link2: "https://design.hse.ru/join#ask",
      text1: isMobile ? t('main_hse_page.more_about_mob') : t('main_hse_page.more_about'),
      text2: isMobile ? t('main_hse_page.question_mob') : t('main_hse_page.question'),
      target: '_blank',
    };

    if (isHSEDesign || isOnlines) {
      return (
        <ButtonWrapper fs hasEmblem={false} isMainPage>
          {is430 && !isOnlines && (
            <ExploreButtonFilled
              fixedSize
              onClick={onCreateClick}
            >
              {t('nav.create')}
            </ExploreButtonFilled>
          )}
          {((!is430 && isHSEDesign) || isOnlines) && (
            <a href={options.link1} target={options.target}>
              <ExploreButtonFilled
                fixedSize
              >
                {options.text1}
              </ExploreButtonFilled>
            </a>
          )}

          <a href={options.link2}>
            <ExploreButtonHollow
              fixedSize
            >
              {options.text2}
            </ExploreButtonHollow>
          </a>
        </ButtonWrapper>
      )
    }
  }, [isMobile, t, isHSEDesign, is430, i18n.language, isOnlines]);

  const serialzeTab = useMemo(() => (isMobile ? (tab || HSEDESIGN_VIEW_TABS.design) : currentTab), [isMobile, currentTab, tab])

  const searchBar = useMemo(
    () => (
      <ProjectsSearchBar
        isLoading={false}
        isCategoriesHidden={
          ApplicationShared.application !== 'geograffee/main' &&
          ApplicationShared.application !== 'deziiign/main'
        }
        sorting={sorting}
        hideRightBar={isHSEDesign || isOnlines || isMap}
        hideLeftBar={isHSEDesign || isOnlines}
        hideRightButtons
        onCategoryChange={onCategoryChange}
        onTagsChange={onTagsChange}
        onSortingChange={onSortingChange}
        onExtraFilterChange={onExtraFilterChange}
        extraFilter={extraFilter}
        display={flipDisplay(display)}
        onDisplayChange={() => {
          setDisplay(flipDisplay(display));
        }}
      />
    ),
    [
      display,
      sorting,
      isDeziiign,
      isHSEDesign,
      onCategoryChange,
      onSortingChange,
      onExtraFilterChange,
      extraFilter,
      onTagsChange,
      setDisplay,
      i18n.language,
      isMobile
    ],
  );

  const descriptionLines = useMemo(() => (is743 ? 9 : 4), [is743]);

  const convertSorting = (s: any) => {
    if (isHSEDesign || isOnlines) {
      return s === 1 ? HSE_SORTING_IDX['1'] : s === 20 ? HSE_SORTING_IDX['20'] : HSE_SORTING_IDX['2']
    }
    return s === 1 ? OLD_HSE_SORTING_IDX.date : OLD_HSE_SORTING_IDX.popular
  }

  const projectsFilter = useMemo(() => ({
    projectFilter: convertSorting(sorting),
    projectStatus,
    categoryIds,
    isLite: true,
    limit: isMap ? 20000 : InfinityScrollNeeded ? offset : 40,
    mainPage: true,
    ...contextFilter,
    ...extraFilter,
    ...tagExtraFilter,
    requestContext: 'main',
  }), [sorting, categoryIds, contextFilter, extraFilter, InfinityScrollNeeded, convertSorting, tagExtraFilter]);

  const mainTitle = useMemo(() => {
    if (isAgeytomesh) {
      return `agey tomesh`;
    }
    if (isOnlines) {
      return 'Portfolio';
    }
    if (isDeziiign || isHseDeziiign) {
      return sortingTitle + "\u00A0" + ((AppTester.isMainContext() || isHseDeziiign) ? t('ctxTitlePart.portfolio') : t("ctxTitlePart." + ctx));
    }
    if (isMediiia) {
      return 'mediiia.com';
    }

    return sortingTitle + ' ' + t('ctxTitlePart.' + ctx);

  }, [t, ctx, sortingTitle, isAgeytomesh, isHseDeziiign, isOnlines]);

  const MobileDropdownTabs = useMemo(() => {
    if (!isOnlines) {
      return (
        <DropdownTabs
          whiteTheme={false} 
          activeTabKey={currentTab}
          items={{
            [HSEDESIGN_VIEW_TABS.design]: t('tab_names.design'),
            [HSEDESIGN_VIEW_TABS.art]: t('tab_names.art'),
            [HSEDESIGN_VIEW_TABS.fashion]: t('tab_names.fashion'),
            [HSEDESIGN_VIEW_TABS.illustration]: t('tab_names.illustration'),
            [HSEDESIGN_VIEW_TABS.all]: t('tab_names.all'),
          }}
          onChange={(tab) => {
            setCurrentTab(tab as HSEDESIGN_VIEW_TABS);
            setQueryParams({ /*page: 1, */tab }, { replace: true });
            sessionStorage.setItem('lastTab', tab)
          }}
        />
      )
    }
  }, [currentTab, setQueryParams ])


  const onMobileSortingClick = useCallback(() => {
    setSorting(sorting == 1 ? 20 : sorting === 20 ? 2 : 1);
  }, [sorting, setSorting]);

  if (display === DisplayType.map) {
    return (
      <>
        <MapFrame
          zoom={zoom}
          coords={[Number(coords[0]), Number(coords[1])]}
          filter={projectsFilter}
          // onCoordsChanged={onCoordsChanged}
          onZoomChange={onZoomChanged}
          isIFrame={isIFrame}
          iframePort={iframePort}
        />
        {isIFrame && <IFrameGlobal />}
      </>
    );
  }

  return (
    <Outer isHse={isHSEDesign}>
      <BodyOverflowStyle/>
      {(isHSEDesignContext() || isHSEDesignOnlineContext()) && !isHseDeziiign ? (
        <IndexTitle/>
      ) : (
        <>
          {!isOnlines && (
            <Title id="explore_view_title" color={theme.exploreView.titleColor}>
              {mainTitle}
            </Title>
          )}
          {isOnlines && (
            <FlexBox width={'100%'} justify={'center'}>
              <OnlinesSpaceGrotesk className='onlines-font'>ONLINES DESIGN SCHOOL</OnlinesSpaceGrotesk>
            </FlexBox>
          )}
        </>
      )}

      {(isMobile && !AppTester.isHSEDesign() && !isAgeytomesh && !isOnlines) &&
      <FlexBox style={{ minHeight: '44px', width: isMobile ? "100%" : "368px" }} offsetBottom={33}
               offsetBottomMobile={0}>
        <MobileSearchBar placeholder={t('search_mob')}/>
      </FlexBox>}

      {!isOnlines && (
        <BottomGroupWrapper titleIsTabs={false}>
          <OuterWrapper
            disableOffset={is430 || (isHSEDesign && !isMobile)}
            align="center"
            directionMobile="column" 
            alignMobile="flex-start"
          >
            <DescriptionWrapper>
              <ShowMoreContent
                more={t('show_more_text')}
                less={t('show_less_text')}
                importantStyles
                isOnlines={isOnlines}
                lines={descriptionLines}>
                {t(`description_into_tab.${isOnlines ? 'onlines' : isAlumni ? 'alumni' : 'main'}`)}
              </ShowMoreContent>
            </DescriptionWrapper>
          </OuterWrapper>
        </BottomGroupWrapper>
      )}
      {isOnlines && (
        <>
          <OuterWrapper
            disableOffset={is430}
            align="center"
            directionMobile="column" 
            alignMobile="flex-start"
          >
            {!isOnlines && (
              <FlexBox direction='row' justify='flex-end' width='100%'>
                <FlexBox direction='row' widthMobile='100%'>
                  {(isMobile && !is430) ? (
                    <MobileFilterRow
                      importantWidth
                      fixed={isMobile && isScrollTop}
                      style={{ width: '100%', justifyContent: 'space-between' }}
                    >
                      {is430 ? (
                        <MobileFilterSort onClick={onMobileSortingClick}>
                          <SortIcon/>
                          {t(`sorting_type.${sorting == 1 ? 'latest' : sorting === 20 ? 'relevant': 'popular'}`)}
                        </MobileFilterSort>
                      ) : (
                        <ProjectSearchBarSorting
                          selectedSorting={sorting ?? 1}
                          onSortingChange={onSortingChange}
                          sortingMethods={[1,2,20]}
                          
                        />
                      )}
                    </MobileFilterRow>
                  ) : (
                    <>
                      {!is430 && (
                        <ProjectSearchBarSorting
                          selectedSorting={sorting}
                          onSortingChange={onSortingChange}
                          sortingMethods={[1,2,20]}
                        />
                      )}
                    </>
                  )}
                </FlexBox>
              </FlexBox>
            )}
          </OuterWrapper>
          <DescriptionWrapper>
            <ShowMoreContent
              more={t('show_more_text')}
              less={t('show_less_text')}
              importantStyles
              isOnlines={isOnlines}
              lines={6}>
              {t(`description_into_tab.${isOnlines ? 'onlines' : 'main'}`)}
            </ShowMoreContent>
            <Description isOnlines={isOnlines}>
              {t(`description_into_tab.${isOnlines ? 'onlines' : 'main'}`)}
            </Description>
          </DescriptionWrapper>
        </>
      )}

      {(isHSEDesign || isOnlines) && (
        <BottomOuterContainer align="center" disabledMobOffset={is430 && !isOnlines}>
          {btnWrapper}
          {(is430 && !isOnlines )
          ? <FlexBox></FlexBox>
          : is830
          ? <FlexBox widthMobile={"100%"} justifyMobile={isOnlines ? "space-between" : 'flex-start'} directionMobile='column'>
            <FlexBox className={'test'} justifyMobile="flex-end">{searchBar}</FlexBox>
            {!isOnlines && (
              <FlexBox directionMobile='row' justifyMobile='space-between' offsetTopMobile={28}>
                {MobileDropdownTabs}
                <ProjectSearchBarSorting
                  selectedSorting={sorting ?? 1}
                  onSortingChange={onSortingChange}
                  sortingMethods={[1,2,20]}
                />
              </FlexBox>
            )}
          </FlexBox>
          : searchBar}
        </BottomOuterContainer>
      )}

      {!isOnlines && !is830 && (<FlexBox direction={'row'} justify='space-between' offsetTop={24} offsetTopMobile={0}>
        {!isMobile ? (
            <FlexBox style={{ placeItems: 'center', position: 'relative' }}>
              <SlideNavigation
                  activeIndexKey={currentTab}
                  onChange={(tab) => {
                    setCurrentTab(tab as HSEDESIGN_VIEW_TABS);
                    setQueryParams({ /*page: 1,*/ tab }, { replace: true });
                    sessionStorage.setItem('lastTab', tab)
                  }}
                  items={{
                    [HSEDESIGN_VIEW_TABS.design]: t('tab_names.design'),
                    [HSEDESIGN_VIEW_TABS.art]: t('tab_names.art'),
                    [HSEDESIGN_VIEW_TABS.fashion]: t('tab_names.fashion'),
                    [HSEDESIGN_VIEW_TABS.illustration]: t('tab_names.illustration'),
                    [HSEDESIGN_VIEW_TABS.all]: t('tab_names.all'),
                  }}
                  isLoading={false}
                  sceletonOptions={sceletonOptions}
                  hoverPopup={!isMobile}
                  hoverContent={preloadedTabs}
                  hoverDataName={{
                    [HSEDESIGN_VIEW_TABS.design]: HSEDESIGN_VIEW_TABS.design,
                    [HSEDESIGN_VIEW_TABS.art]: HSEDESIGN_VIEW_TABS.art,
                    [HSEDESIGN_VIEW_TABS.fashion]: HSEDESIGN_VIEW_TABS.fashion,
                    [HSEDESIGN_VIEW_TABS.illustration]: HSEDESIGN_VIEW_TABS.illustration,
                    [HSEDESIGN_VIEW_TABS.all]: HSEDESIGN_VIEW_TABS.all,
                  }}
              />
            </FlexBox>
        ) : MobileDropdownTabs}

        <FlexBox direction='row' widthMobile='100%'>
          {(isMobile && !is430) ? (
              <MobileFilterRow
                  importantWidth
                  fixed={isMobile && isScrollTop}
                  style={{ width: '100%', justifyContent: 'flex-end' }}
              >
                {is430 ? (
                    <MobileFilterSort onClick={onMobileSortingClick}>
                      <SortIcon/>
                      {t(`sorting_type.${sorting == 1 ? 'latest' : sorting === 20 ? 'relevant' : 'popular'}`)}
                    </MobileFilterSort>
                ) : (
                    <ProjectSearchBarSorting
                        selectedSorting={sorting ?? 1}
                        onSortingChange={onSortingChange}
                        sortingMethods={[1,2,20]}
                    />
                )}
              </MobileFilterRow>
          ) : (
              <>
                {!is430 && (
                    <ProjectSearchBarSorting
                        selectedSorting={sorting}
                        onSortingChange={onSortingChange}
                        sortingMethods={[1,2,20]}
                    />
                )}
              </>
          )}
        </FlexBox>
      </FlexBox>)}

      {isMobile && !isHSEDesign && !isOnlines && (
        <OuterWrapper>
          <MobileFilterRow fixed={isMobile && isScrollTop} style={{ marginTop: 0, paddingTop: 0 }}>
            <TagsTextBar
              onClick={() =>
                modal.show('tags', {
                  mode: 'link',
                })
              }
            />
            <MobileFilterSort onClick={onMobileSortingClick}>
              <SortIcon/>
              {t(`sorting_type.${sorting == 1 ? 'latest' : sorting === 20 ? 'relevant' : 'popular'}`)}
            </MobileFilterSort>
          </MobileFilterRow>
        </OuterWrapper>
      )}


      {is430 && (
        <FlexBox widthMobile={'100%'} directionMobile={isOnlines ? 'row' : "column"} offsetTopMobile={27} justifyMobile={isOnlines ? 'space-between' : 'flex-start'}>
          {searchBar}
          {!isOnlines && (
            <FlexBox justifyMobile='space-between' widthMobile={'100%'} offsetTopMobile={28}>
              {MobileDropdownTabs}
              <MobileFilterRow
                importantWidth
                fixed={isMobile && isScrollTop}
                style={{ width: '100%', justifyContent: 'flex-end' }}
              >
                {is430 ? (
                  <MobileFilterSort onClick={onMobileSortingClick}>
                    <SortIcon/>
                    {t(`sorting_type.${sorting == 1 ? 'latest' : sorting === 20 ? 'relevant' : 'popular'}`)}
                  </MobileFilterSort>
                ) : (
                  <ProjectSearchBarSorting
                    selectedSorting={sorting ?? 1}
                    onSortingChange={onSortingChange}
                    sortingMethods={[1,2,20]}
                  />
                )}
              </MobileFilterRow>
            </FlexBox>
          )}

        </FlexBox>
      )}

      <ProjectControllerWrapper>
        <ProjectsButchController
          filter={projectsFilter}
          onProjectsLoaded={setProjects}
          isInfinityNeed={InfinityScrollNeeded}
          projectsCount={projects?.length}
          date={date}
          preloadedTabs={preloadedTabs}
          currentTab={serialzeTab}
          isPageWithoutTabs={!isHSEDesign}
          withoutQueryParams
          isMainPage={true}
        />
      </ProjectControllerWrapper>
    </Outer>
  );
};
import { FC, lazy, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { createGlobalStyle, css, useTheme } from 'styled-components';
import { FInter, FlexBox, useBreakpoint, useIsMobile } from '@brg/ui';
import { Project, Tag } from '@brg/api';

import { ProjectsSearchBar, } from '../../components/projectsSearchBar/projectsSearchBar';
import { ICategoryLight } from '../../common';
import { ApplicationShared, CoreContainer, LayoutConst, useModal } from '../../../core';
import { DisplayType } from '../../constants/displayType';
import { SortingTypeIndex } from '../../constants/sortingType';
import { CreateLinkTo, LinkTo } from '../../constants/linkTo';
import { AppTester, getContextFromAppName, getCurrentAppName } from '../../../supporting';
import { isHSEDesignContext } from '../../../_deziiign/hsedesign/utils';
import { IndexTitle, OnlinesSpaceGrotesk } from '../../../_deziiign/hsedesign/components/IndexTitle';
import { ProjectsButchController } from '../../../core/controllers/ProjectsButchController';
import { EncodedStateFilter, useEncodedStateFilter } from '../../components/Filters'
import { flipDisplay } from '../../utils/display'
import { isHSEDesignOnlineContext } from '../../../_deziiign/online/utils';
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import './styles';

import {
  ADVERTISING_TAG_ID,
  ART_DIRECTION_TAG_ID,
  ART_TAG_ID,
  BASIC_DESIGN_TA_ID,
  BOOK_DESIGN_TAD_ID,
  CANTEMPORARY_ART_TAG_ID,
  COMMUNICATION_TAG_ID,
  CREATIVE_PROGRAMMING_TAG_ID,
  DESIGN_TAG_ID,
  DIGITAL_PRODUCT_TAG_ID,
  DURASOV_TAG_ID,
  FASHION_TAG_ID,
  HSEILLUSTRATION_TAG_ID,
  INTERACTIVE_DESIGN_TAG_ID,
  JEWELRY_TAG_ID,
  MEDIA_DESIGN_TAG_ID,
  MODERN_DESIGN_TAG_ID,
  OBJECT_DESIGN_TAG_ID,
  PACKAGING_TAG_ID,
  PHOTOGRAPHY_ART_TAG_ID,
  SOUND_ART_TAG_ID,
  TYPE_TAG_ID,
  VIDEO_ART_ART_TAG_ID,
  VISUAL_RES_TAG_ID_BL,
  VISUAL_RESEARCH_TAG_GRADUATION_BLACK,
  WEB_PUBLISH_TAG_ID
} from "../../constants/misc";

import {SortIcon} from '../../icons';
import useExtraFilter from "../../hooks/useExtraFilter";
import TagsTextBar from 'shared/components/TagsTextBar/TagsTextBar';
import useQueryState from 'shared/hooks/useQueryState';
import MobileSearchBar from 'shared/components/MobileSearchBar/MobileSearchBar';
import {SlideNavigation} from 'shared/components/slideNavigation';
import {
  BottomGroupWrapper,
  ButtonWrapper,
  Description,
  DescriptionWrapper,
  ExploreButtonFilled,
  ExploreButtonHollow,
  IFrameGlobal,
  OuterWrapper,
  ProjectControllerWrapper,
  BottomOuterContainer
} from './styles';
import {ProjectSearchBarSorting} from '../../components/projectsSearchBar/components/projectSearchBarSorting';
import {useDispatch, useSelector} from 'react-redux';
import {InfinityProjectsSelector} from 'shared/reducers/InfinityProjects';
import {ShowMoreContent} from '../designer/styles';
import {HseContextActions} from 'shared/reducers/hseCurrentContext';
import {useAuth} from '@brg/auth';
import {HSE_SORTING_IDX} from '../exploreHseContextsOldDeprecated/const/sorting_tsx';
import {DropdownTabs} from '../exploreHseContextsOldDeprecated/components/DropdownTabs';
import useScreenOffset from "../../hooks/useScreenOffset";
import useQuery from "../../hooks/useQuery";
import { Outer } from './styles';

const MapFrame = lazy(() => import("../ResearchPage/Research/Frames/MapFrame"));

const getUrl = (encodedState: string) => {
  if (window.location.pathname.startsWith('/map')) {
    return `/map/${encodedState}`;
  }
  if (window.location.pathname.startsWith('/deziiign')) {
    return `/deziiign/${encodedState}`;
  }
  if (AppTester.isOnlineHSEDesign()) {
    return '/projects' + CreateLinkTo.explore(encodedState)
  }
  return CreateLinkTo.explore(encodedState);
}

export enum HSEDESIGN_VIEW_TABS {
  design = 'design',
  art = 'art',
  fashion = 'fashion',
  illustration = 'illustration',
  all = 'all',
}
const OLD_HSE_SORTING_IDX = {
  "date": 14,
  "popular": 15
}

const sceletonOptions = {
  col: 4,
  w: 65,
  h: 20,
  gx: 10
}

const TAB_TAGS = {
  [HSEDESIGN_VIEW_TABS.design]: DESIGN_TAG_ID,
  [HSEDESIGN_VIEW_TABS.art]: ART_TAG_ID,
  [HSEDESIGN_VIEW_TABS.fashion]: FASHION_TAG_ID,
  [HSEDESIGN_VIEW_TABS.illustration]: HSEILLUSTRATION_TAG_ID,
  [HSEDESIGN_VIEW_TABS.all]: '',
}

const getTagFilterParam = (str: string) => {
  //@ts-ignore
  switch (TAB_TAGS[str]) {
    case DESIGN_TAG_ID:
      return [
        ADVERTISING_TAG_ID,
        ART_DIRECTION_TAG_ID,
        WEB_PUBLISH_TAG_ID,
        BOOK_DESIGN_TAD_ID,
        BASIC_DESIGN_TA_ID,
        COMMUNICATION_TAG_ID,
        CREATIVE_PROGRAMMING_TAG_ID,
        DIGITAL_PRODUCT_TAG_ID,
        INTERACTIVE_DESIGN_TAG_ID,
        MEDIA_DESIGN_TAG_ID,
        MODERN_DESIGN_TAG_ID,
        OBJECT_DESIGN_TAG_ID,
        PACKAGING_TAG_ID,
        TYPE_TAG_ID
      ]

    case ART_TAG_ID:
      return [
        CANTEMPORARY_ART_TAG_ID,
        PHOTOGRAPHY_ART_TAG_ID,
        VIDEO_ART_ART_TAG_ID
      ]

    case FASHION_TAG_ID:
      return [FASHION_TAG_ID, JEWELRY_TAG_ID]
    case HSEILLUSTRATION_TAG_ID:
      return [HSEILLUSTRATION_TAG_ID]
    default:
      return null
  }
}


const projectStatus = [1, 6];


export const ExploreView: FC= () => (
  <EncodedStateFilter getUrl={getUrl}>
    <ExploreViewInner/>
  </EncodedStateFilter>
);

export const Title = styled(FInter.MainTitleMediumDiv)`
  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 36px;
    line-height: 39px;
  }
`;

export const MobileFilterRow = styled.div<{ fixed?: boolean, importantWidth?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  ${(p) =>
          p?.fixed ? css`
            position: sticky;
            top: 48px;
            left: 0;
            width: auto;
            z-index: 99;
            background-color: ${p => p.theme.app.backgroundColor};
          ` : null}

  ${p => p.importantWidth ? css`
    width: 100%;
  ` : css`
    .ExploreViewInnerSearchTags {
      width: calc(100% - 100px);
    }
  `};

`;

export const MobileFilterSort = styled.div<{isLectureMedia?: boolean}>`
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: #909090;
  display: flex;
  align-items: center;

  ${({isLectureMedia}) => isLectureMedia && css`
    width: 145px;
    justify-content: flex-end;
  `}


  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

const ONLINES_PROJECT_INDEX = {
  1:
    "6ee1e54530f94f7780a5de98473a50b6",
  2:
    "b1e7ff644881488c9d90508feb43aaec",
  3:
    "1da8a8f928c847c185424d0799566fa2",
  4:
    "d095fa3d66ac466eac5ee8726cc73624",
  5:
    "bdb65705630b446bba6e8aa8e56a770b",
  6:
    "25d62d8eb0d24f049909cc039eabc6dc",
  7:
    "c0d68aba984d4eb79b2c398bf0b64ef1",
  8:
    "f333f38db48d4f49be966279882badaa",
  9:
    "78b3756c96f9447398d515ccf9cc4570",
  10:
    "4e6ce404cc294b6bbe2c85e10bf1b4e4",
  11:
    "59004c2e416c4a67a9d9db60edfa4e5e",
  12:
    "c8b400684d28485f913ad1cb0f0db25b",
  13:
    "789471b400e04d1e937169f86a9637b7",
  14:
    "2343708ca49f4e9e8f64991edb893e29",
  15:
    "4b0cfa65f2fb48d298e7fe0b07408b2d",
  16:
    "81efec2b492749f0a4b742d67812671f",
  17:
    "1de7210a0d0c4ee18ba27f4268f236ba",
  18:
    "9eee16ddba454c23a68432b554cc05d8",
  19:
    "d98e99fd878c4106aec7c84b2de73ddc",
  20:
    "ecac2ea4717843509d62ee5e4e70b220",
  21:
    "99150d626ec642d38b78378a5cee36a3",
  22:
    "7d411e61c69b4182b100b4025560f4d4",
  23:
    "a718c69553f34d31902708ccc7d2d4a5",
  24:
    "6c1835fd3d8d4921a1359025d154d22f",
  25:
    "158ead9efa1b4484bcfe1d1b720dadf9",
  26:
    "f971516688564bcf928fd35147b8bc5d",
  27:
    "957244c386d647ab88a4f50681c4d939",
  28:
    "1740a69fe35c4e9b83a4f3b4355ca011",
  29:
    "7cb092aa11584529aae1040bd126f1f8",
  30:
    "bed506e4c8754ba99d49d92098aeff59",
  31:
    "2f31b48203744d33a6951743e3a01c4a",
  32:
    "8fd94fa37ea04698a5e398a9e0df2c7d",
  33:
    "0919be6a05cb44fd9ad506b2a8ec0f84",
  34:
    "34fdba9e6090499fabc74bce0d14e098",
  35:
    "3c769f84d5504de6a716880b1828d0c7",
  36:
    "66ec15dd34fd4df59c936b17ad002038",
  37:
    "3c079419eb934e69bd616ff4564b6ac5",
  38:
    "1a32fc89c81348dcb1f2a864ea0b170a",
  39:
    "b4d486361af547b3be20259db823385c",
  40:
    "be196307d2914e85a67a25e11c4e0b10",
  41:
    "8efb8cc5066a44cd87066aba034cb864",
  42:
    "24bd5d27b18b48da86fd384e56768220",
  43:
    "9d2af64f6d624b60bf0e1d0d27c5e4a9",
  // 44:
  //   "90e08c46f80a4d1c943e79cf0c0bee1b",
  // 45:
  //   "4fef355b7ed8421b989c00eefc53602d",
  46:
    "974b5cfc690a404fbc4bc801d283b6af",
  47:
    "bcac028a01bb49df9e8e44b3b8c18f74",
  48:
    "a63c669a51984e4a9647be92668f2c5f",
  49:
    "e68ed2ce24294dd4ae037f5f45d773b1",
  50:
    "e6ae1dc6f9884a70bfe964c5fc6cfaba",
  51:
    "bcccee6eb19f4243872825d50cae1486",
  52:
    "cdc0d6bfd41644908db35d43835844a2",
  53:
    "d9da04ec4bd34350a8a603b1d2d6d722",
  54:
    "422e3d5b569941098bbc18ef103d2cff",
  55:
    "d5d007d27ecd4643822d0e0a5292d52f",
  56:
    "4811c9c857bb4b59a5de941b26e4baaa",
  57:
    "b6c8aa6605124cf9bef30e87a93e5819",
  58:
    "3ac9ad49c9d04a78b2f0cac2ad36f647",
  59:
    "5ea19804d1f14f6887787c57791d02ed",
  60:
    "56311823a38540bcb03d8b1ae966d7da",
  61:
    "c6b3472238bb411dac19561afb28d57b",
  62:
    "e90e9f0961b44dbca268e0ceb4070a6f",
  63:
    "758605d8281b49678ff33bc5a8555739",
  64:
    "c413e4915b0b4cb2925f7b34d607aa05",
  65:
    "70c13a513926454cab68cb4b2cd3be82",
  66:
    "8ba43ad663f548308b3435bf4a054894",
  67:
    "54d3fcf36eef446bb364bad479f5f170",
  68:
    "b7961d8966b24d60bd8de471737625e3",
  69:
    "2134550deefe449a838b1c89b1c66e58",
  70:
    "e71d463b590b4e07a4ca3cad0857d72d",
}

const ONLINES_PROJECT_ARRAY = [
  'b3eed99da0984d89abe6e38c9dd7071b',
  'b1e7ff644881488c9d90508feb43aaec',
  '52a5a72ddb5c4010ad154e9bf2d371c1',
  '5135677c840a4b8f9526394a3cafdac4',
  '444ff9724a3d4b9d9448059710cc030a',
  '63d2a338d14a446b86d52fe435c3003f',
  '1620c3f8edcc42f5b1e21ce69c02f23f',
  'f7c6633b2c204a209c09a8c48376c122',
  ...Object.values(ONLINES_PROJECT_INDEX)
];

export const ONLINES_PROJECT_ORDER_INDEX = ONLINES_PROJECT_ARRAY.reduce((result, item, index) => {
  return {
    ...result,
    [item]: index,
  }
}, {})


const BodyOverflowStyle = createGlobalStyle`
  body {
    overflow-y: scroll !important;
  }
`

const ExploreViewInner: FC = () => {
  const {
    sorting: sortingRaw,
    coords,
    zoom,
    display,
    tagIds,
    categoryIds,
    setSorting,
    setCoords,
    setZoom,
    setDisplay,
    setTagIds,
    setCategoryIds
  } = useEncodedStateFilter();
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const offset = useScreenOffset();
  const isMobile = useIsMobile();
  const location = useLocation();
  const { emit, token } = useAuth();
  const modal = useModal();
  const history = useHistory();
  const dispatch = useDispatch();
  const isAllProjectsPage = useRouteMatch(LinkTo.deziiign);
  const isDurasov = !!useRouteMatch(LinkTo.durasov);
  const isSamokatMap = !!useRouteMatch(LinkTo.samokatMap);
  const isOnlines = AppTester.isOnlines();
  const currentAppName = getCurrentAppName();
  const isDeziiign = currentAppName === 'deziiign';
  const isMediiia = currentAppName === 'mediiia';
  const isHseDeziiign = !!isAllProjectsPage;
  const isAgeytomesh = AppTester.isAgeytomesh();
  const isHSEDesign = AppTester.isHSEDesign();
  const isIFrame = location.pathname.includes('iframepath')
  const isMap = display === DisplayType.map;
  const variables = useQuery();
  const isAlumni = !!useRouteMatch('/alumni');

  const sorting = Number(sortingRaw);

  const is430 = useBreakpoint(430);
  const is830 = useBreakpoint(830);
  const is743 = useBreakpoint(743);

  const isBack = useSelector(InfinityProjectsSelector)?.isProjectPage;
  const prevTab = sessionStorage.getItem('lastTab');

  const [currentTab, setCurrentTab] = useState<HSEDESIGN_VIEW_TABS>(HSEDESIGN_VIEW_TABS.design);
  const [{ tab }, setQueryParams] = useQueryState();

  const [isScrollTop, setScrollTop] = useState<boolean>(false);
  const [iframePort, setIiframePort] = useState<any>(null)
  const [date, setDate] = useState(Date.now());
  const [extraFilter, onExtraFilterChange] = useExtraFilter();

  const tagExtraFilter = useMemo(
    () => (
      (((isBack && prevTab) ? prevTab : currentTab) === HSEDESIGN_VIEW_TABS.all || !isHSEDesign) ?
        {} :
        { tagIds: getTagFilterParam((isBack && prevTab) ? prevTab : currentTab) })
    , [currentTab, prevTab, isBack, isHSEDesign])

  useEffect(() => {
    if (isSamokatMap) setQueryParams({ display: 'map' }, { replace: true });
  }, [isSamokatMap])

  const preloadedTabs = useMemo(() => {
    return Object.entries(TAB_TAGS)?.map(([k, v]) => ({
      [k]: getTagFilterParam(k)
    }));
  }, [TAB_TAGS, getTagFilterParam])


  const sortingTitle = useMemo(
    () => sorting === 1 ? t('text.mainTitleByNew') : t('text.mainTitleByPopular'),
    [sorting, t]
  );

  const InfinityScrollNeeded = useMemo(
    () => ((AppTester.isHSEDesign() || AppTester.isDeziiign() || AppTester.isOnlines() || AppTester.isGeograffee()) && (location.pathname === '/' || location.pathname.startsWith('/alumni') ||  AppTester.isOnlines() || location.pathname.startsWith('/projects') || variables.display === 'grid'))
    , [location])

  const [projects, setProjects] = useState<Project[]>([]);

  const contextFilter = useMemo(() => {
    if (isAgeytomesh) {
      return { contexts: ["ageytomesh"], isContextIgnored: false };
    }
    if (isDurasov) {
      return { tagIds: [DURASOV_TAG_ID], isContextIgnored: true };
    }
    if (isHseDeziiign) {
      return { isContextIgnored: true };
    }
    if (isOnlines) {
      return {
        projectFilter: 2,
        projectIds: [
          ...ONLINES_PROJECT_ARRAY,
        ],
        limit: 200,
        projectStatus: [1],
        isContextIgnored: true,
        isLite: true,
        mainPage: true,
      }
    }
    if (isHSEDesign) {
      return {
        tagIds,
        isFilterReplaceTags: true,
        contexts: ['hsedesign'],
      };
    }
    return { tagIds };
  }, [isAgeytomesh, isHseDeziiign, tagIds, isDurasov]);


  useEffect(() => {
    if (isHSEDesign) {
    }
    return () => {
      dispatch(HseContextActions.reset({}));
    }
  }, [dispatch, isHSEDesign])

  useEffect(() => {
    if (!isOnlines) {
      if (isBack && prevTab && Object.values(HSEDESIGN_VIEW_TABS).includes(prevTab as HSEDESIGN_VIEW_TABS)) {
        setQueryParams({ tab: prevTab }, { replace: true });
        setCurrentTab(prevTab as HSEDESIGN_VIEW_TABS);
      }
    }
  }, [currentTab, setQueryParams, isBack, prevTab, tab, isOnlines])

  useEffect(() => {
    setProjects([])
    setDate(Date.now())
  }, [tagExtraFilter])

  useEffect(() => {
    if (categoryIds.length > 0 && ApplicationShared.application !== 'education') {
      setDate(Date.now())
    }
  }, [categoryIds]);

  useEffect(() => {
    if (isMap) {
      setDate(Date.now())
    }
  }, [isMap])

  const scrollInterval = () => {
    const val_1 = window.scrollY;
    setTimeout(() => {
      let res = window.scrollY
      if (res && res < val_1) {
        setScrollTop(true)
      }
    }, 1000)
  }

  const onIframeMessage = (msg: MessageEvent) => {}

  const onSetIframePort = (msg: MessageEvent) => {
    if(msg?.ports?.length) {
      const usedPort = msg?.ports[0]
      usedPort.onmessage = onIframeMessage
      setIiframePort(usedPort)
    }
  }

  useEffect(() => {
    let intervalId = setInterval(scrollInterval, 1000)
    if(isIFrame) {
      window.addEventListener('message', onSetIframePort)
    }
    return (() => {
      clearInterval(intervalId);
      window.removeEventListener('message', onSetIframePort)
    })
  }, [])

  const onTagsChange = useCallback(([firstTag]: Tag[]): void => {
    setTagIds([firstTag?.tagId])
    history.push(firstTag ? CreateLinkTo.tag(firstTag.tagId) : CreateLinkTo.explore())
    setDate(Date.now());
  }, [setTagIds, history]);

  const onCategoryChange = useCallback((category: ICategoryLight): void => {
    setCategoryIds(category.identifier !== 'all' && category.identifier ? [category.identifier] : []);
    setDate(Date.now());
  }, [setCategoryIds]);

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
    setDate(Date.now());
  }, [setSorting]);

  // const onCoordsChanged = useCallback((newCoords: any): void => {
  //   setCoords(newCoords);
  // }, [setCoords]);

  const onZoomChanged = useCallback((zoom: number): void => {
    setZoom(zoom);
  }, [setZoom]);

  const onCreateClick = useCallback(() => {
    if (token) {
      history.push(CreateLinkTo.projectCreate());
    } else {
      emit('login');
    }
  }, [token, history, emit]);

  const ctx = useMemo(() => {
    const ctx = getContextFromAppName(ApplicationShared.application);
    return ctx !== 'main' ? `${ctx}` : 'geograffee';
  }, []);

  const btnWrapper = useMemo(() => {
    const options = isOnlines ? {
      link1: "https://onlinesdesign.com/graphic-design-basic-level#form",
      link2: "https://onlinesdesign.com/school",
      text1: t('onlinesNav.btns.learning'),
      text2: t('onlinesNav.btns.about'),
      target: '_self',
    } : {
      link1: "https://design.hse.ru/",
      link2: "https://design.hse.ru/join#ask",
      text1: isMobile ? t('main_hse_page.more_about_mob') : t('main_hse_page.more_about'),
      text2: isMobile ? t('main_hse_page.question_mob') : t('main_hse_page.question'),
      target: '_blank',
    };

    if (isHSEDesign || isOnlines) {
      return (
        <ButtonWrapper fs hasEmblem={false} isMainPage>
          {is430 && !isOnlines && (
            <ExploreButtonFilled
              fixedSize
              onClick={onCreateClick}
            >
              {t('nav.create')}
            </ExploreButtonFilled>
          )}
          {((!is430 && isHSEDesign) || isOnlines) && (
            <a href={options.link1} target={options.target}>
              <ExploreButtonFilled
                fixedSize
              >
                {options.text1}
              </ExploreButtonFilled>
            </a>
          )}

          <a href={options.link2}>
            <ExploreButtonHollow
              fixedSize
            >
              {options.text2}
            </ExploreButtonHollow>
          </a>
        </ButtonWrapper>
      )
    }
  }, [isMobile, t, isHSEDesign, is430, i18n.language, isOnlines]);

  const serialzeTab = useMemo(() => (isMobile ? (tab || HSEDESIGN_VIEW_TABS.design) : currentTab), [isMobile, currentTab, tab])

  const searchBar = useMemo(
    () => (
      <ProjectsSearchBar
        isLoading={false}
        isCategoriesHidden={
          ApplicationShared.application !== 'geograffee/main' &&
          ApplicationShared.application !== 'deziiign/main'
        }
        sorting={sorting}
        hideRightBar={isHSEDesign || isOnlines || isMap}
        hideLeftBar={isHSEDesign || isOnlines}
        hideRightButtons
        onCategoryChange={onCategoryChange}
        onTagsChange={onTagsChange}
        onSortingChange={onSortingChange}
        onExtraFilterChange={onExtraFilterChange}
        extraFilter={extraFilter}
        display={flipDisplay(display)}
        onDisplayChange={() => {
          setDisplay(flipDisplay(display));
        }}
      />
    ),
    [
      display,
      sorting,
      isDeziiign,
      isHSEDesign,
      onCategoryChange,
      onSortingChange,
      onExtraFilterChange,
      extraFilter,
      onTagsChange,
      setDisplay,
      i18n.language,
      isMobile
    ],
  );

  const descriptionLines = useMemo(() => (is743 ? 9 : 4), [is743]);

  const convertSorting = (s: any) => {
    if (isHSEDesign || isOnlines) {
      return s === 1 ? HSE_SORTING_IDX['1'] : s === 20 ? HSE_SORTING_IDX['20'] : HSE_SORTING_IDX['2']
    }
    return s === 1 ? OLD_HSE_SORTING_IDX.date : OLD_HSE_SORTING_IDX.popular
  }

  const projectsFilter = useMemo(() => ({
    projectFilter: convertSorting(sorting),
    projectStatus,
    categoryIds,
    isLite: true,
    limit: isMap ? 20000 : InfinityScrollNeeded ? offset : 40,
    mainPage: true,
    ...contextFilter,
    ...extraFilter,
    ...tagExtraFilter,
    requestContext: 'main',
  }), [sorting, categoryIds, contextFilter, extraFilter, InfinityScrollNeeded, convertSorting, tagExtraFilter]);

  const mainTitle = useMemo(() => {
    if (isAgeytomesh) {
      return `agey tomesh`;
    }
    if (isOnlines) {
      return 'Portfolio';
    }
    if (isDeziiign || isHseDeziiign) {
      return sortingTitle + "\u00A0" + ((AppTester.isMainContext() || isHseDeziiign) ? t('ctxTitlePart.portfolio') : t("ctxTitlePart." + ctx));
    }
    if (isMediiia) {
      return 'mediiia.com';
    }

    return sortingTitle + ' ' + t('ctxTitlePart.' + ctx);

  }, [t, ctx, sortingTitle, isAgeytomesh, isHseDeziiign, isOnlines]);

  const MobileDropdownTabs = useMemo(() => {
    if (!isOnlines) {
      return (
        <DropdownTabs
          whiteTheme={false} 
          activeTabKey={currentTab}
          items={{
            [HSEDESIGN_VIEW_TABS.design]: t('tab_names.design'),
            [HSEDESIGN_VIEW_TABS.art]: t('tab_names.art'),
            [HSEDESIGN_VIEW_TABS.fashion]: t('tab_names.fashion'),
            [HSEDESIGN_VIEW_TABS.illustration]: t('tab_names.illustration'),
            [HSEDESIGN_VIEW_TABS.all]: t('tab_names.all'),
          }}
          onChange={(tab) => {
            setCurrentTab(tab as HSEDESIGN_VIEW_TABS);
            setQueryParams({ /*page: 1, */tab }, { replace: true });
            sessionStorage.setItem('lastTab', tab)
          }}
        />
      )
    }
  }, [currentTab, setQueryParams ])


  const onMobileSortingClick = useCallback(() => {
    setSorting(sorting == 1 ? 20 : sorting === 20 ? 2 : 1);
  }, [sorting, setSorting]);

  if (display === DisplayType.map) {
    return (
      <>
        <MapFrame
          zoom={zoom}
          coords={[Number(coords[0]), Number(coords[1])]}
          filter={projectsFilter}
          // onCoordsChanged={onCoordsChanged}
          onZoomChange={onZoomChanged}
          isIFrame={isIFrame}
          iframePort={iframePort}
        />
        {isIFrame && <IFrameGlobal />}
      </>
    );
  }

  return (
    <Outer isHse={isHSEDesign}>
      <BodyOverflowStyle/>
      {(isHSEDesignContext() || isHSEDesignOnlineContext()) && !isHseDeziiign ? (
        <IndexTitle/>
      ) : (
        <>
          {!isOnlines && (
            <Title id="explore_view_title" color={theme.exploreView.titleColor}>
              {mainTitle}
            </Title>
          )}
          {isOnlines && (
            <FlexBox width={'100%'} justify={'center'}>
              <OnlinesSpaceGrotesk className='onlines-font'>ONLINES DESIGN SCHOOL</OnlinesSpaceGrotesk>
            </FlexBox>
          )}
        </>
      )}

      {(isMobile && !AppTester.isHSEDesign() && !isAgeytomesh && !isOnlines) &&
      <FlexBox style={{ minHeight: '44px', width: isMobile ? "100%" : "368px" }} offsetBottom={33}
               offsetBottomMobile={0}>
        <MobileSearchBar placeholder={t('search_mob')}/>
      </FlexBox>}

      {!isOnlines && (
        <BottomGroupWrapper titleIsTabs={false}>
          <OuterWrapper
            disableOffset={is430 || (isHSEDesign && !isMobile)}
            align="center"
            directionMobile="column" 
            alignMobile="flex-start"
          >
            <DescriptionWrapper>
              <ShowMoreContent
                more={t('show_more_text')}
                less={t('show_less_text')}
                importantStyles
                isOnlines={isOnlines}
                lines={descriptionLines}>
                {t(`description_into_tab.${isOnlines ? 'onlines' : isAlumni ? 'alumni' : 'main'}`)}
              </ShowMoreContent>
            </DescriptionWrapper>
          </OuterWrapper>
        </BottomGroupWrapper>
      )}
      {isOnlines && (
        <>
          <OuterWrapper
            disableOffset={is430}
            align="center"
            directionMobile="column" 
            alignMobile="flex-start"
          >
            {!isOnlines && (
              <FlexBox direction='row' justify='flex-end' width='100%'>
                <FlexBox direction='row' widthMobile='100%'>
                  {(isMobile && !is430) ? (
                    <MobileFilterRow
                      importantWidth
                      fixed={isMobile && isScrollTop}
                      style={{ width: '100%', justifyContent: 'space-between' }}
                    >
                      {is430 ? (
                        <MobileFilterSort onClick={onMobileSortingClick}>
                          <SortIcon/>
                          {t(`sorting_type.${sorting == 1 ? 'latest' : sorting === 20 ? 'relevant': 'popular'}`)}
                        </MobileFilterSort>
                      ) : (
                        <ProjectSearchBarSorting
                          selectedSorting={sorting ?? 1}
                          onSortingChange={onSortingChange}
                          sortingMethods={[1,2,20]}
                          
                        />
                      )}
                    </MobileFilterRow>
                  ) : (
                    <>
                      {!is430 && (
                        <ProjectSearchBarSorting
                          selectedSorting={sorting}
                          onSortingChange={onSortingChange}
                          sortingMethods={[1,2,20]}
                        />
                      )}
                    </>
                  )}
                </FlexBox>
              </FlexBox>
            )}
          </OuterWrapper>
          <DescriptionWrapper>
            <ShowMoreContent
              more={t('show_more_text')}
              less={t('show_less_text')}
              importantStyles
              isOnlines={isOnlines}
              lines={6}>
              {t(`description_into_tab.${isOnlines ? 'onlines' : 'main'}`)}
            </ShowMoreContent>
            <Description isOnlines={isOnlines}>
              {t(`description_into_tab.${isOnlines ? 'onlines' : 'main'}`)}
            </Description>
          </DescriptionWrapper>
        </>
      )}

      {(isHSEDesign || isOnlines) && (
        <BottomOuterContainer align="center" disabledMobOffset={is430 && !isOnlines}>
          {btnWrapper}
          {(is430 && !isOnlines )
          ? <FlexBox></FlexBox>
          : is830
          ? <FlexBox widthMobile={"100%"} justifyMobile={isOnlines ? "space-between" : 'flex-start'} directionMobile='column'>
            <FlexBox className={'test'} justifyMobile="flex-end">{searchBar}</FlexBox>
            {!isOnlines && (
              <FlexBox directionMobile='row' justifyMobile='space-between' offsetTopMobile={28}>
                {MobileDropdownTabs}
                <ProjectSearchBarSorting
                  selectedSorting={sorting ?? 1}
                  onSortingChange={onSortingChange}
                  sortingMethods={[1,2,20]}
                />
              </FlexBox>
            )}
          </FlexBox>
          : searchBar}
        </BottomOuterContainer>
      )}

      {!isOnlines && !is830 && (<FlexBox direction={'row'} justify='space-between' offsetTop={24} offsetTopMobile={0}>
        {!isMobile ? (
            <FlexBox style={{ placeItems: 'center', position: 'relative' }}>
              <SlideNavigation
                  activeIndexKey={currentTab}
                  onChange={(tab) => {
                    setCurrentTab(tab as HSEDESIGN_VIEW_TABS);
                    setQueryParams({ /*page: 1,*/ tab }, { replace: true });
                    sessionStorage.setItem('lastTab', tab)
                  }}
                  items={{
                    [HSEDESIGN_VIEW_TABS.design]: t('tab_names.design'),
                    [HSEDESIGN_VIEW_TABS.art]: t('tab_names.art'),
                    [HSEDESIGN_VIEW_TABS.fashion]: t('tab_names.fashion'),
                    [HSEDESIGN_VIEW_TABS.illustration]: t('tab_names.illustration'),
                    [HSEDESIGN_VIEW_TABS.all]: t('tab_names.all'),
                  }}
                  isLoading={false}
                  sceletonOptions={sceletonOptions}
                  hoverPopup={!isMobile}
                  hoverContent={preloadedTabs}
                  hoverDataName={{
                    [HSEDESIGN_VIEW_TABS.design]: HSEDESIGN_VIEW_TABS.design,
                    [HSEDESIGN_VIEW_TABS.art]: HSEDESIGN_VIEW_TABS.art,
                    [HSEDESIGN_VIEW_TABS.fashion]: HSEDESIGN_VIEW_TABS.fashion,
                    [HSEDESIGN_VIEW_TABS.illustration]: HSEDESIGN_VIEW_TABS.illustration,
                    [HSEDESIGN_VIEW_TABS.all]: HSEDESIGN_VIEW_TABS.all,
                  }}
              />
            </FlexBox>
        ) : MobileDropdownTabs}

        <FlexBox direction='row' widthMobile='100%'>
          {(isMobile && !is430) ? (
              <MobileFilterRow
                  importantWidth
                  fixed={isMobile && isScrollTop}
                  style={{ width: '100%', justifyContent: 'flex-end' }}
              >
                {is430 ? (
                    <MobileFilterSort onClick={onMobileSortingClick}>
                      <SortIcon/>
                      {t(`sorting_type.${sorting == 1 ? 'latest' : sorting === 20 ? 'relevant' : 'popular'}`)}
                    </MobileFilterSort>
                ) : (
                    <ProjectSearchBarSorting
                        selectedSorting={sorting ?? 1}
                        onSortingChange={onSortingChange}
                        sortingMethods={[1,2,20]}
                    />
                )}
              </MobileFilterRow>
          ) : (
              <>
                {!is430 && (
                    <ProjectSearchBarSorting
                        selectedSorting={sorting}
                        onSortingChange={onSortingChange}
                        sortingMethods={[1,2,20]}
                    />
                )}
              </>
          )}
        </FlexBox>
      </FlexBox>)}

      {isMobile && !isHSEDesign && !isOnlines && (
        <OuterWrapper>
          <MobileFilterRow fixed={isMobile && isScrollTop} style={{ marginTop: 0, paddingTop: 0 }}>
            <TagsTextBar
              onClick={() =>
                modal.show('tags', {
                  mode: 'link',
                })
              }
            />
            <MobileFilterSort onClick={onMobileSortingClick}>
              <SortIcon/>
              {t(`sorting_type.${sorting == 1 ? 'latest' : sorting === 20 ? 'relevant' : 'popular'}`)}
            </MobileFilterSort>
          </MobileFilterRow>
        </OuterWrapper>
      )}


      {is430 && (
        <FlexBox widthMobile={'100%'} directionMobile={isOnlines ? 'row' : "column"} offsetTopMobile={27} justifyMobile={isOnlines ? 'space-between' : 'flex-start'}>
          {searchBar}
          {!isOnlines && (
            <FlexBox justifyMobile='space-between' widthMobile={'100%'} offsetTopMobile={28}>
              {MobileDropdownTabs}
              <MobileFilterRow
                importantWidth
                fixed={isMobile && isScrollTop}
                style={{ width: '100%', justifyContent: 'flex-end' }}
              >
                {is430 ? (
                  <MobileFilterSort onClick={onMobileSortingClick}>
                    <SortIcon/>
                    {t(`sorting_type.${sorting == 1 ? 'latest' : sorting === 20 ? 'relevant' : 'popular'}`)}
                  </MobileFilterSort>
                ) : (
                  <ProjectSearchBarSorting
                    selectedSorting={sorting ?? 1}
                    onSortingChange={onSortingChange}
                    sortingMethods={[1,2,20]}
                  />
                )}
              </MobileFilterRow>
            </FlexBox>
          )}

        </FlexBox>
      )}

      <ProjectControllerWrapper>
        <ProjectsButchController
          filter={projectsFilter}
          onProjectsLoaded={setProjects}
          isInfinityNeed={InfinityScrollNeeded}
          projectsCount={projects?.length}
          date={date}
          preloadedTabs={preloadedTabs}
          currentTab={serialzeTab}
          isPageWithoutTabs={!isHSEDesign}
          withoutQueryParams
          isMainPage={true}
        />
      </ProjectControllerWrapper>
    </Outer>
  );
};
